import React, { useEffect } from 'react'
import './PriceListStyle.css'
const PriceListPhoneMenu = props => {
    useEffect(() => {
        document.getElementById('btn4').click();
    }, [])
    return (
        <div className="menu" style={{ marginTop: "10px", marginBottom: "20px" }} id={"services"}>
            <input className="menu_input" id="btn2" name="menu" type="radio" />
            <label onClick={() => props.setPackage(2)} className="menu_label" htmlFor="btn2">
                <div className="fa">1</div>
                <div className="menu_text">
                    בסיסי
                </div>
            </label>
            <input className="menu_input" id="btn3" name="menu" type="radio" />
            <label onClick={() => props.setPackage(3)} className="menu_label" htmlFor="btn3">
                <div className="fa">2</div>
                <div className="menu_text">
                    מתקדם
                </div>
            </label>
            <input className="menu_input menu_input_suggested" id="btn4" name="menu" type="radio" />
            <label onClick={() => props.setPackage(4)} className="menu_label" htmlFor="btn4">
                <div className="fa">3</div>
                <div className="menu_text">
                    מומלץ
                </div>
            </label>
            <input className="menu_input menu_input_vip" id="btn5" name="menu" type="radio" />
            <label onClick={() => props.setPackage(5)} className="menu_label" htmlFor="btn5">
                <div className="fa">4</div>
                <div className="menu_text">
                    vip
                </div>
            </label>
        </div>
    )
}

export default PriceListPhoneMenu;

